import { Table as BaseTable } from '@/components_deprecated'
import { format, parseISO } from 'date-fns'
import React from 'react'
import styled from 'styled-components'
import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import { ALL_DRIVER_COMMENTS } from '../../queries'

const Wrapper = styled.div`
  margin-top: 2rem;

  & > h2 {
    margin: 1rem 0 0 8px;
    font-weight: 600;
  }
`

const Table = styled(BaseTable)`
  position: relative;
  margin-top: 1rem;

  ${props => props.theme.media.largePad}
  ${props => props.theme.media.mobile} {
    overflow: auto;
  }

  td.absence-info {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 12px 1rem;
    height: 56px;

    span {
      color: ${props => props.theme.colors.gray5};
      font-weight: 600;
    }
  }
`

interface CommentTableProps {
  startDate: Date
  endDate: Date
  userId: string
}

export const SimpleCommentTable: React.FC<CommentTableProps> = ({
  startDate,
  endDate,
  userId,
}) => {
  const translations = useTranslate({
    date: 'common.date',
    comments: 'common.comments',
  })
  const { data, loading } = useQuery(ALL_DRIVER_COMMENTS, {
    variables: {
      datetimeGt: startDate.toISOString(),
      datetimeLt: endDate.toISOString(),
      user: userId,
    },
  })

  const driverComments = data?.allDriverComments ?? []

  return !loading && driverComments.length > 0 ? (
    <Wrapper>
      <h2>{translations.comments}</h2>
      <Table>
        <thead>
          <tr>
            <th>{translations.date}</th>
            <th>{translations.comments}</th>
          </tr>
        </thead>

        <tbody>
          {driverComments.map(comment => {
            const date = comment.date ? parseISO(comment.date) : new Date()

            return (
              <tr key={comment.id}>
                <td>{format(date, 'dd. MMM HH:mm')}</td>
                <td>{comment.comment}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </Wrapper>
  ) : (
    <></>
  )
}
